import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { getImageInfo } from "../redux/getImage/imageAction";
// import { getTitleInfo } from "../redux/getTitle/titleAction";
import { BiSolidRightArrow } from "react-icons/bi";
import { MdOutlineTimer } from "react-icons/md";
import quickLogo from "../../assets/quicky.png";
import "../Access.css";

import { getEventInfo } from "../../redux/getEvent/eventAction";
import EventDetail from "./EventDetails";

const EventDetails = ({ readTime }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qValue = queryParams.get("q");
  const [imageUrl, setImageUrl] = useState("");
  const [titleUrl, setTitleUrl] = useState("");
  const [message, setMessage] = useState("");
  const [event, setEvent] = useState();
  const dispatch = useDispatch();
  console.log(qValue);
  console.log(imageUrl);

  useEffect(() => {
    // Fetch the image data using getImageInfo action
    dispatch(getEventInfo(qValue)).then((response) => {
      console.log(response);
      if (response && response?.status === "success") {
        setImageUrl(response?.baseUrl);
        setEvent(response?.data[0]);
      }
      //   // Update the imageUrl state with the data from the response
      //   setImageUrl(response.data);
      //   setTitleUrl(response.title);
      //   setMessage(response.message);
      // }
    });

    // Fetch the title data using getTitleInfo action
    // dispatch(getTitleInfo(qValue)).then((response) => {
    //   if (response && response.status === "success") {
    //     // Update the titleUrl state with the data from the response
    //     setTitleUrl(response.title);
    //   }
    // });
  }, [qValue, dispatch]);

  return (
    <div className="lg:mt-20 max-w-7xl mx-auto px-5">
      <div className="main-div">
        <div className="quickLogo">
          <img src={quickLogo} alt="logo" />
        </div>
        <div className="quick-guide">
          <div className="quick-label">
            <BiSolidRightArrow />
          </div>
          <h2 className="quick-text">LIFEBANK EVENTS</h2>
        </div>
        <div className="prevent-div">
          <p className="prevent-text capitalize">{event?.name}</p>
          <div className="page-p"></div>
        </div>
      </div>
      {/* Display the image if imageUrl is available */}

      {imageUrl && (
        <div className="max-w-7xl mx-auto">
          {" "}
          <img
            src={`https://${imageUrl}/${event?.header}`}
            className="lg:w-full object-contain"
            alt={message}
          />
        </div>
      )}
      <EventDetail eventDetail={event} />
    </div>
  );
};

export default EventDetails;
